<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15AzVr3/tc-custom/9780374720759.jpg?1732048062410" alt="This image is the cover for the book Everything Is Under Control"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Is Under Control
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fast-paced, heart-smacking memoir” detailing one woman’s life journey as a dancer, pastry chef, and mother (<i>Bon Appétit</i>).</b><br/><br/><b>One of <i>Esquire</i>’s Best Cookbooks of 2020 and<i> Washington Post</i>’s Best Food Books of 2020</b><br/><br/><b>“What a beautiful, rich, and poetic memoir this is. . . . Like the best chefs, Phyllis Grant knows how to make a masterpiece from a few simple ingredients: truth, taste, poignancy, and love.” —Elizabeth Gilbert, author of <i>City of Girls</i> and <i>Eat, Pray, Love</i></b><br/><br/>Phyllis Grant’s <i>Everything Is Under Control</i> is a story about appetite—as it comes, goes, and refocuses its object of desire. Grant’s revealing memoir follows the sometimes smooth, sometimes jagged, always revealing contours of her life: from her days as a dancer struggling to find her place at Julliard, to her experiences in and out of four-star kitchens in New York City, to falling in love with her future husband and leaving the city after 9/11 for California, where her children are born. All the while, a sense of longing pulses in each stage as she moves through the headspace of a young woman yearning to be sustained by a city into that of a mother now sustaining a family herself.<br/><br/>Written with the transparency of a diarist, <i>Everything Is Under Control</i> is an unputdownable series of vignettes followed by tried-and-true recipes from Grant’s table—a heartrending yet unsentimental portrait of the highs and lows of young adulthood, motherhood, and a life in the kitchen.<br/><br/><b>“A truly distinct perspective. . . . [A] damn fine writer. . . . Distinguished by her keen attention to the sublime detail and a voice as eviscerating as it is lyrical. . . . Transcendent.” —<i>The New York Times Book Review</i></b><br/><br/><b>“Phyllis Grant has the voice of a poet and the sensuality of a cook. This very brave book makes you want to experience the world with equal intensity. As for the recipes . . . completely irresistible.” —Ruth Reichl, author of <i>Save Me the Plums</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phyllis Grant
      </h2>
      
      <p class="authorDescription body article">Phyllis Grant is an IACP finalist for Personal Essays/Memoir Writing and a three-time <I>Saveur</I> Food Blog Award finalist for her blog, <I>Dash and Bella</I>. She has cooked in world-renowned restaurants, including Nobu, Michael’s, and Bouley. Her essays and recipes have been published in a dozen anthologies and cookbooks, including <I>Best Food Writing</I> in both 2015 and 2016. Her work has been featured in <I>Esquire</I>,<I> O, The Oprah Magazine</I>, <I>The New York Times</I>, <I>Real Simple</I>, <I>Saveur</I>, <I>HuffPost</I>, <I>Time</I>, <I>San Francisco Chronicle</I>, <I>Food52</I>, and <I>Salon</I>. She lives in Berkeley, California, with her husband and two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6692a49e